<template>
    <div class="step_content">
        <div class="operation_wrapper">
            <span class="step_icon border_leftT"></span>
            <span class="step_icon border_rightT"></span>
            <span class="step_icon border_leftB"></span>
            <span class="step_icon border_rightB"></span>
            <h3 class="task-name-info">任务名称：<span>{{taskName}}</span></h3>
            <div class="extract_opt_wrapper">
                <span class="step_opt_title">随机分组</span>
                <span class="step_opt_icon border_opt_leftT"></span>
                <span class="step_opt_icon border_opt_rightT"></span>
                <span class="step_opt_icon border_opt_leftB"></span>
                <span class="step_opt_icon border_opt_rightB"></span>
                <span class="extract_info extract_info_left">本次执法人员有：<el-button type="text" @click="extractPersonPondDialog=true">{{extractPondPersonList.length}} 个</el-button></span>
                <span class="extract_info extract_info_right">执法人员共分为：{{form.groupNum}} 组</span>
                <el-scrollbar :style="{'height':persinListHeight,'min-height':'150px'}">
                    <el-row v-if="extractIngFlag">
                        <el-col :span="24" v-for="i in form.groupNum" :key="i" style="text-align: center" >
                            <div class="extract_person_box">
                                <span class="extract_person_circle">{{i}}</span>
                                <vue-seamless-scroll v-for="j in form.groupAvg" :key="j" :data="extractPondPersonListShuffle" class="seamless-person-warp" :class-option="classOption">
                                    <p v-for="(item,index) in extractPondPersonListShuffle" :key="index">{{item.personName}}</p>
                                </vue-seamless-scroll>
                                <div style="clear: both"></div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!extractIngFlag">
                        <el-col :span="24" v-for="i in form.groupNum" :key="i" style="text-align: center" >
                            <el-row v-if="historyid == 0">
                                <div class="extract_person_box">
                                    <span class="extract_person_circle">{{i}}</span>
                                    <div class="seamless-person-warp" v-for="(item,index) in extractPondResult" ::key="index" v-if="item.groupNo == i">
                                        <p>{{item.personName}}</p>
                                    </div>
                                    <div style="clear: both"></div>
                                </div>
                            </el-row>
                            <el-row v-else>
                                <div class="extract_person_box">
                                    <span class="extract_person_circle">{{i}}</span>
                                    <div class="seamless-person-warp" v-for="j in form.groupAvg" :key="j">
                                        <p>***</p>
                                    </div>
                                    <div style="clear: both"></div>
                                </div>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-scrollbar>
                <br>
                <el-button type="primary" plain v-if="!extractIngFlag" class="start-extract-btn" :disabled="historyid == 0"  @click="startExtract()">开始分组</el-button>
                <el-button type="primary" plain v-if="extractIngFlag" @click="getExtractResult(true)">停止</el-button>
                <br>
                <el-button type="text" style="margin-top: 10px" @click="showExtractResult()" :disabled="historyid != 0">查看抽取结果</el-button>
            </div>
        </div>

        <div class="btn_wraper" style="text-align: center">
            <p class="supervisionNameInfo">监督检查单位：{{supervisionIdsName}}</p>
            <el-tooltip class="item" popper-class="bigScreenPopper" :visible-arrow="false" effect="light" placement="top-start">
                <div slot="content">
                    {{supervisionIdsName}}
                </div>
                <el-button type="text" style="float:right"> 更多> </el-button>
            </el-tooltip>
            <el-button @click="prevStep()" :disabled="extractIngFlag" plain>上一步</el-button>
            <el-button type="primary" @click="nextStep()" :disabled="historyid != 0" plain>下一步</el-button>
        </div>
        <el-dialog title="执法检查人员随机分组结果" :visible.sync="extractPondResultDialog">
            <template>
                <el-row>
                    <el-col :span="24" v-for="i in form.groupNum" :key="i" style="text-align: center" >
                        <div class="extract_person_box">
                            <span class="extract_person_circle">{{i}}</span>
                            <div class="seamless-person-warp" v-for="(item,index) in extractPondResult" ::key="index" v-if="item.groupNo == i">
                                <p>{{item.personName}}</p>
                            </div>
                            <div style="clear: both"></div>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click="extractPondResultDialog = false" type="primary">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="'本次进入抽取的执法检查人员共有：'+ extractPondPersonList.length + '个'"  :visible.sync="extractPersonPondDialog">
            <template>
                <el-row>
                    <p style="color: #FFFFFF;text-indent: 32px">本次执法人员分别为：<span v-for="(item,index) in extractPondPersonList">{{item.personName + (item.personDesc?("（" + item.personDesc + "）"):'')}}；</span></p>
                </el-row>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click="extractPersonPondDialog = false" type="primary">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import vueSeamlessScroll from 'vue-seamless-scroll';
    export default {
        name: "step_five",
        components: {
            vueSeamlessScroll
        },
        props:{
            activeStep: {type: Number, default: 1},
            curStep: {type: Number, default: 1},
            historyid: {type: Number, default: -1},
            taskName: {type: String, default: ''},
            supervisionIdsName: {type: String, default: ''},
            groupNum: {type: Number, default: 1},
        },
        data(){
            return{
                id:"",
                persinListHeight: document.documentElement.clientHeight - 750  + 'px',
                form:{
                    id:'',
                    taskId:"",
                    extractCode:"",
                    extractTime:"",
                    extractNum:"",
                    groupNum:1,
                    groupAvg:1,
                    extractorName:"",
                    curStep:"",
                },
                extractIngFlag:false,
                extractPondResult:[],
                extractPondResultDialog:false,
                extractPersonPondDialog:false,
                extractPondPersonList:[],
                extractPondPersonListShuffle:[],
                stepSpeed:0,
            }
        },
        filters:{

        },
        created(){
            this.form.taskId = this.$route.query.id || '';
            this.getExtractExectorList()

        },
        computed: {
            ...mapState({
                stateData:state=>state.user
            }),
            classOption() {
                return {
                    step: 10, // 数值越大速度滚动越快
                    limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                    hoverStop: false, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: false, // 开启数据实时监控刷新dom
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
                }
            }
        },
        methods:{
            shuffle(arr){
                arr = JSON.parse(JSON.stringify(arr))
                var newArr = [];
                var len = arr.length;
                for(var i=0; i<len; i++){
                    var index = Math.floor(Math.random()*arr.length);//随机下标
                    newArr.push(arr[index]);//将随机出的元素，存放新数组newArr中去
                    arr.splice(index,1);//    将随机出的元素在arr中删除
                }
                //arr中删除随机出的元素,arr.length-1,同时i++,导致循环不会10次,会是5次.最后得到newArr中只有一半的随机数字,arr中剩下另一半. 将其合并到一起,得到res
                var res =[...newArr,...arr];
                return res
            },

            // 获取所选择的执法人员和要求分组数
            getExtractExectorList(){
                // 获取所选择的执法人员和分组数
                this.$httpReq.get('/projectDoubleExtract/extractexectorfilter/getPersonAndRule?extractTaskId='+this.form.taskId).then(res=>{
                    if(res.data.code == '1' && res.data.data){
                        this.extractPondPersonList = res.data.data.executorList || [];
                        this.form ={...res.data.data.executorFilter};
                        this.form.groupNum = res.data.data.executorFilter.groupNum || 1;
                        let extractPondPersonListLength = this.extractPondPersonList.length;
                        let groupNum = this.form.groupNum;
                        if(groupNum != 0){
                            this.form.groupAvg = parseInt(extractPondPersonListLength/groupNum);
                        }
                        let extractPondResult = JSON.parse(JSON.stringify(this.extractPondPersonList))
                        this.extractPondResult = extractPondResult
                    }else{
                        this.extractPondPersonList = [];
                        this.form.groupNum = 1;
                    }
                })
            },

            startExtract(){

                this.extractPondPersonListShuffle = this.shuffle(this.extractPondPersonList);

                this.$httpReq.get('/projectDoubleExtract/extractexector/startExtract?taskId='+this.form.taskId).then(res=>{
                    if(res.data.code == '1' ){
                        this.stepSpeed = 20;
                        this.extractPondResult = [];
                        this.extractIngFlag = true;
                    }else{
                        this.$message.error(res.data.msg)
                    }
                })
            },
            getExtractResult(bool){
                this.$httpReq.get('/projectDoubleExtract/extractexector/showExecutorGroup?taskId='+this.form.taskId+'&changeStatus='+(bool?'1':'0')).then(res=>{
                    if(res.data.code == '1' ){

                        const _this = this;
                        var timer = setInterval(function(){
                            _this.stepSpeed--;
                            if(_this.stepSpeed == 5){
                                _this.extractIngFlag = false;
                                _this.extractPondResult = res.data.data;
                            }
                            if(_this.stepSpeed == 0){
                                clearInterval(timer);
                            }
                        },100)

                        this.$emit("upDateTaskInfo")

                    }else{
                        this.stepSpeed = 0;
                        this.extractIngFlag = false;
                        this.$message.error('抽取失败，请重新抽取！')
                    }
                })
            },
            showExtractResult(){
                this.extractPondResultDialog = true
            },
            prevStep(){
                this.$emit("update:activeStep",this.activeStep - 1)
            },
            nextStep(){
                // this.$emit("update:activeStep", this.activeStep + 1)
                // return
                this.$httpReq.get('/projectDoubleExtract/extracttask/updateCurStep?taskId='+this.form.taskId + '&curStep='+(this.activeStep + 1)).then(res=>{})
                this.$emit("update:activeStep",this.activeStep + 1)

            },


        },
    }
</script>

<style lang="scss" scoped>

    .step_content{


        .extract_person_box{
            width:724px;
            background: url(../../../../assets/img/bigScreen/border2.png);
            background-size:100% 100%;
            padding:8px 28px 8px 56px;
            margin: 10px auto;
            position: relative;
            text-align: center;

            .extract_person_circle{
                width:24px;
                height:24px;
                position: absolute;
                color: #FFFFFF;
                border-radius: 50%;
                border:1px solid #5FDCFFFF;
                background-color:#3196FA40 ;
                font-size: 14px;
                line-height: 24px;
                left:16px;
                top:16px;

            }

        }


        .seamless-person-warp{
            height:32px;
            width:112px;
            background-color:rgba(49, 150, 250, 0.15);
            border:1px solid rgba(49, 150, 250, 0.25);
            margin: 4px 8px;
            overflow: hidden;
            border: none;
            display: inline-block;
            p{
                padding: 0;margin: 0;
                line-height: 32px;
                color: #FFFFFF;
            }

        }


        .operation_wrapper{
            .extract_opt_wrapper{
                background: rgba(49, 150, 250, 0.1);
                padding: 8px 48px 32px 48px;
                position: relative;
                .step_opt_title{
                    width: 800px;
                    height: 46px;
                    display: inline-block;
                    font-size: 24px;
                    font-weight: 600;
                    line-height: 32px;
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat 0px -260px;
                }

                .step_opt_icon {
                    width: 80px;
                    height: 80px;
                    position: absolute;
                    display: inline-block;
                }
                .border_opt_leftT {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -654px -161px;
                    left: 10px;
                    top: 10px;
                }

                .border_opt_rightT {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -708px -161px;
                    right: 10px;
                    top: 10px;
                }

                .border_opt_leftB {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -814px -239px;
                    left: 10px;
                    bottom: 10px;
                }

                .border_opt_rightB {
                    background: url(../../../../assets/img/bigScreen/elves.png) no-repeat -787px -160px;
                    right: 10px;
                    bottom: 10px;
                }
                .extract_info{
                    display: inline-block;
                    position: absolute;
                }
                .extract_info_left{
                    left:20px;
                    top:24px;

                }
                .extract_info_right{
                    right:20px;
                    top:24px;
                }


            }



        }

    }



</style>